import BaseService from './base.service';

export default class UserOrgPropertiesService {
    static ENDPOINT = '/users/me/orgs';

    static async getPropertyGuests(orgId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/guests`;
        return BaseService.get(endpoint);
    }

    static async getPropertyAccessKeyById(orgId, propertyId, keyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/access-keys/${keyId}`;
        return BaseService.get(endpoint);
    }

    static async updatePropertyAccessKey(orgId, propertyId, keyId, guestAccessKeyData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/access-keys/${keyId}`;
        return BaseService.patch(endpoint, guestAccessKeyData);
    }

    // static async suspendPropertyAccessKey(orgId, propertyId, keyId, suspended) {
    //     const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/access-keys/${keyId}/suspend`;
    //     return BaseService.patch(endpoint, { suspended: suspended });
    // }

    static async removePropertyAccessKey(orgId, propertyId, keyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/access-keys/${keyId}`;
        return BaseService.delete(endpoint);
    }

    static async inviteGuestToProperty(orgId, propertyId, guestInviteData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/guests/invite`;
        return BaseService.post(endpoint, guestInviteData);
    }

    static async getGuestInviteFromPropertyById(orgId, propertyId, inviteId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/guests/invite/${inviteId}`;
        return BaseService.get(endpoint);
    }

    static async removeGuestInviteFromProperty(orgId, propertyId, inviteId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/guests/invite/${inviteId}`;
        return BaseService.delete(endpoint);
    }

    static async getPropertyOtcs(orgId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/otcs`;
        return BaseService.get(endpoint);
    }

    static async getPropertyOtcById(orgId, propertyId, codeId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/otcs/${codeId}`;
        return BaseService.get(endpoint);
    }

    static async createPropertyOtc(orgId, propertyId, otcData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/otcs`;
        return BaseService.post(endpoint, otcData);
    }

    static async revokePropertyOtc(orgId, propertyId, codeId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/otcs/${codeId}/revoke`;
        return BaseService.patch(endpoint, null);
    }

    static async registerOccupantToProperty(orgId, propertyId, registrationData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants/register`;
        return BaseService.post(endpoint, registrationData);
    }

    static async removeOccupantRegistrationFromProperty(
        orgId,
        propertyId,
        registrationId
    ) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants/register/${registrationId}`;
        return BaseService.delete(endpoint);
    }

    static async getPropertyOccupants(orgId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants`;
        return BaseService.get(endpoint);
    }

    static async getPropertyOccupant(orgId, propertyId, userId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants/${userId}`;
        return BaseService.get(endpoint);
    }

    static async updatePropertyOccupant(orgId, propertyId, userId, occupantData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants/${userId}`;
        return BaseService.patch(endpoint, occupantData);
    }

    static async getPropertyOccupantRegistrationById(orgId, propertyId, registrationId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/occupants/register/${registrationId}`;
        return BaseService.get(endpoint);
    }

    static async getPropertyVisitors(orgId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors`;
        return BaseService.get(endpoint);
    }

    static async getVisitorById(orgId, propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}`;
        return BaseService.get(endpoint);
    }

    static async addVisitor(orgId, propertyId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors`;
        return BaseService.post(endpoint, visitorData);
    }

    static async updateVisitor(orgId, propertyId, visitorId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}`;
        return BaseService.patch(endpoint, visitorData);
    }

    static async removeVisitor(orgId, propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}`;
        return BaseService.delete(endpoint, null);
    }

    // static async suspendVisitor(orgId, propertyId, visitorId, suspended) {
    //     const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}/suspend`;
    //     return BaseService.patch(endpoint, { suspended: suspended });
    // }

    static async getRentalsOnProperty(orgId, propertyId, params = {}) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals`;
        return BaseService.get(endpoint, params);
    }

    // static async getRentalById(orgId, propertyId, rentalId) {
    //     const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals/${rentalId}`;
    //     return BaseService.get(endpoint);
    // }

    static async getRentalsByPropertyId(orgId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals/on-property`;
        return BaseService.get(endpoint);
    }

    static async createRental(orgId, propertyId, rentalData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals`;
        return BaseService.post(endpoint, rentalData);
    }

    static async updateRental(orgId, propertyId, rentalData, rentalId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals/${rentalId}`;
        return BaseService.patch(endpoint, rentalData);
    }

    static async cancelRental(orgId, propertyId, rentalId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/rentals/${rentalId}/cancel`;
        return BaseService.patch(endpoint);
    }
}
